<template>
    <span class="text-red-600 font-normal">*</span>
</template>